import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment reportingHighestSavingPerk on ReportingHighestSavingPerk {
    uuid
    type
    savingsPercentage
    savingsGBP
    savingsAUD
    estimatedSavingsGBP
    estimatedSavingsAUD
    deal {
      cardImage
      brandName
    }
  }
`

export default fragment
